<admin-app-header></admin-app-header>

<div class="admyt-tenants-page admyt-page">
    <div class="container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <h1>Admyt Tenants</h1>
            <div class="page-header__actions">
                <button class="admyt-btn-secondary" (click)="refreshData()" [disabled]="loadingTenants || !selectedCenterId">
                    <i class="fa-solid fa-refresh" [class.fa-spin]="loadingTenants"></i> Refresh
                </button>
            </div>
        </div>

        <!-- Center Selection Card -->
        <div class="admyt-card">
            <div class="admyt-card__header">
                <h4>
                    <i class="fa-solid fa-building me-2"></i>
                    Select Center
                    <span class="data-source data-source--admyt ms-2"><i class="fa-solid fa-cloud"></i> Admyt</span>
                </h4>
            </div>
            
            <!-- Loading centers -->
            <div *ngIf="loadingCenters" class="text-center py-3">
                <i class="fa-solid fa-spinner fa-spin"></i> Loading centers...
            </div>
            
            <!-- Center selector -->
            <div *ngIf="!loadingCenters" class="row align-items-center">
                <div class="col-md-6">
                    <label class="form-label fw-bold">Choose a center to view its tenants:</label>
                    <select class="form-select form-select-lg" [(ngModel)]="selectedCenterId" (change)="onCenterChange()">
                        <option value="">-- Select a Center --</option>
                        <option *ngFor="let center of centers" [value]="center.id">{{ center.name }}</option>
                    </select>
                </div>
                <div class="col-md-6" *ngIf="selectedCenter">
                    <div class="d-flex align-items-center gap-3 mt-3 mt-md-0">
                        <a [routerLink]="['/admin/admyt-center', selectedCenterId]" class="admyt-btn-primary">
                            <i class="fa-solid fa-building"></i> View Center Details
                        </a>
                    </div>
                </div>
            </div>
            
            <p *ngIf="!loadingCenters && centers.length === 0" class="text-muted mt-2 mb-0">
                No centers found. Please check your Admyt configuration.
            </p>
        </div>

        <!-- Show rest of page only when a center is selected -->
        <ng-container *ngIf="selectedCenterId">
            <!-- Summary Stats -->
            <div class="admyt-stat-cards" *ngIf="!loadingTenants && !error">
                <div class="admyt-stat-card admyt-stat-card--purple">
                    <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                    <div class="admyt-stat-card__icon">
                        <i class="fa-solid fa-building"></i>
                    </div>
                    <div class="admyt-stat-card__content">
                        <span class="admyt-stat-card__label">Selected Center</span>
                        <span class="admyt-stat-card__value">{{ selectedCenter?.name }}</span>
                    </div>
                </div>
                <div class="admyt-stat-card admyt-stat-card--blue">
                    <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                    <div class="admyt-stat-card__icon">
                        <i class="fa-solid fa-id-card"></i>
                    </div>
                    <div class="admyt-stat-card__content">
                        <span class="admyt-stat-card__label">Total Tenants</span>
                        <span class="admyt-stat-card__value">{{ tenants.length }}</span>
                    </div>
                </div>
                <div class="admyt-stat-card admyt-stat-card--green">
                    <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                    <div class="admyt-stat-card__icon">
                        <i class="fa-solid fa-user-check"></i>
                    </div>
                    <div class="admyt-stat-card__content">
                        <span class="admyt-stat-card__label">Active</span>
                        <span class="admyt-stat-card__value">{{ getActiveTenants() }}</span>
                    </div>
                </div>
                <div class="admyt-stat-card admyt-stat-card--orange">
                    <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                    <div class="admyt-stat-card__icon">
                        <i class="fa-solid fa-car"></i>
                    </div>
                    <div class="admyt-stat-card__content">
                        <span class="admyt-stat-card__label">Total Bays</span>
                        <span class="admyt-stat-card__value">{{ getTotalBays() }}</span>
                    </div>
                </div>
            </div>

            <!-- Filter Bar -->
            <div class="filter-bar" *ngIf="!loadingTenants && !error && tenants.length > 0">
                <div class="filter-bar__left">
                    <div class="filter-search">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        <input type="text" 
                               class="filter-input" 
                               placeholder="Search by name or ID..." 
                               [(ngModel)]="searchTerm" 
                               (input)="onSearchChange()" />
                    </div>
                    <div class="status-toggle">
                        <button *ngFor="let statusOption of availableStatuses" 
                                class="toggle-btn" 
                                [class.active]="statusFilter === statusOption" 
                                (click)="statusFilter = statusOption; onStatusFilterChange()">
                            {{ statusOption | titlecase }}
                        </button>
                    </div>
                </div>
                <div class="filter-bar__right">
                    <select class="items-select" [(ngModel)]="itemsPerPage" (change)="onSearchChange()">
                        <option value="10">10 per page</option>
                        <option value="20">20 per page</option>
                        <option value="50">50 per page</option>
                        <option value="100">100 per page</option>
                    </select>
                    <span class="results-count">{{ filteredTenants.length }} results</span>
                </div>
            </div>

            <!-- Loading Tenants State -->
            <div class="loading-state" *ngIf="loadingTenants">
                <i class="fa-solid fa-spinner fa-spin"></i>
                <p>Loading tenants for {{ selectedCenter?.name }}...</p>
            </div>

            <!-- Error State -->
            <div class="error-state" *ngIf="error">
                <i class="fa-solid fa-exclamation-triangle"></i>
                <h3>Error Loading Tenants</h3>
                <p>{{ error }}</p>
                <button class="btn btn-primary" (click)="refreshData()">
                    <i class="fa-solid fa-refresh"></i> Try Again
                </button>
            </div>

            <!-- Empty State -->
            <div class="empty-state" *ngIf="!loadingTenants && !error && tenants.length === 0">
                <i class="fa-solid fa-id-card"></i>
                <h3>No Tenants Found</h3>
                <p>There are no tenants registered in {{ selectedCenter?.name }}.</p>
            </div>

            <!-- No matching results after filtering -->
            <div class="empty-state" *ngIf="!loadingTenants && !error && tenants.length > 0 && filteredTenants.length === 0">
                <i class="fa-solid fa-search"></i>
                <h3>No Matching Tenants</h3>
                <p>No tenants match your search criteria. Try adjusting your filters.</p>
            </div>

            <!-- Tenants Table -->
            <div class="admyt-card p-0" *ngIf="!loadingTenants && !error && filteredTenants.length > 0">
                <table class="admyt-table">
                    <thead>
                        <tr>
                            <th>Tenant ID <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i></span></th>
                            <th>Tenant Name</th>
                            <th>Subscription <span class="data-source data-source--parkupp"><i class="fa-solid fa-database"></i></span></th>
                            <th>Status</th>
                            <th>Bays</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let tenant of getPaginatedTenants(); trackBy: trackByTenantId" class="tenant-row">
                            <td>
                                <code>{{ truncate(tenant.id, 12) }}</code>
                            </td>
                            <td>
                                <strong>{{ tenant.name }}</strong>
                            </td>
                            <td>
                                <a *ngIf="getSubscriptionFromTenantName(tenant.name)" 
                                   [routerLink]="['/admin/subscription', getSubscriptionFromTenantName(tenant.name)]" 
                                   class="admyt-link">
                                    <i class="fa-solid fa-file-signature"></i>
                                    {{ truncate(getSubscriptionFromTenantName(tenant.name), 10) }}
                                </a>
                                <span *ngIf="!getSubscriptionFromTenantName(tenant.name)" class="text-muted">
                                    <i class="fa-solid fa-unlink"></i> Not linked
                                </span>
                            </td>
                            <td>
                                <span class="admyt-status" 
                                      [class.admyt-status--active]="tenant.status === 'active'"
                                      [class.admyt-status--inactive]="tenant.status === 'inactive'"
                                      [class.admyt-status--pending]="tenant.status === 'pending'">
                                    {{ tenant.status | titlecase }}
                                </span>
                            </td>
                            <td>
                                <span class="admyt-status admyt-status--active">
                                    <i class="fa-solid fa-car"></i> {{ tenant.baysNumber }}
                                </span>
                            </td>
                            <td>
                                <div class="d-flex gap-1">
                                    <button class="btn btn-outline-primary btn-sm" (click)="viewTenant(tenant)" title="View tenant details">
                                        <i class="fa-solid fa-eye"></i>
                                    </button>
                                    <a *ngIf="getSubscriptionFromTenantName(tenant.name)" 
                                       [routerLink]="['/admin/subscription', getSubscriptionFromTenantName(tenant.name)]" 
                                       class="btn btn-outline-secondary btn-sm"
                                       title="View subscription">
                                        <i class="fa-solid fa-file-signature"></i>
                                    </a>
                                    <button class="btn btn-outline-danger btn-sm" 
                                            (click)="deactivateTenant(tenant)" 
                                            [disabled]="tenant.status === 'inactive'"
                                            title="Deactivate tenant">
                                        <i class="fa-solid fa-ban"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Pagination -->
            <div class="pagination-wrapper" *ngIf="!loadingTenants && !error && filteredTenants.length > 0 && totalPages > 1">
                <div class="pagination-info">
                    Showing {{ (currentPage - 1) * itemsPerPage + 1 }} to {{ Math.min(currentPage * itemsPerPage, totalItems) }} of {{ totalItems }} tenants
                </div>
                <div class="pagination">
                    <button class="page-btn" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
                        <i class="fa-solid fa-chevron-left"></i>
                    </button>
                    <button *ngFor="let page of getPageNumbers()" 
                            class="page-btn" 
                            [class.active]="page === currentPage" 
                            (click)="goToPage(page)">
                        {{ page }}
                    </button>
                    <button class="page-btn" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">
                        <i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </ng-container>

        <!-- Prompt to select a center -->
        <div *ngIf="!loadingCenters && !selectedCenterId && centers.length > 0" class="text-center py-5">
            <i class="fa-solid fa-building fa-3x text-muted mb-3"></i>
            <h4 class="text-muted">Select a Center to View Tenants</h4>
            <p class="text-muted">Choose a center from the dropdown above to load and view its tenants.</p>
        </div>
    </div>
</div>
